import React from 'react';
import { ShieldCheck } from 'lucide-react';
export const Guarantee = () => {
  return <section className="py-20 bg-white" data-id="element-76">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-77">
        <div className="bg-green-50 rounded-3xl p-10 md:p-14 border border-green-100 shadow-lg" data-id="element-78">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-green-100 rounded-full mb-8" data-id="element-79">
            <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-80" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-81">
            Garantía 7 días sin preguntas
          </h2>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-82">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            clase.
            <br data-id="element-83" />
            Si no es lo que esperabas → 100% de devolución. Sin preguntas. Sin
            formularios. Sin drama.
          </p>
          <div className="inline-block bg-white px-6 py-3 rounded-full text-green-700 font-bold text-sm border border-green-200 shadow-sm" data-id="element-84">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </div>
    </section>;
};